import './index.scss';

$(document).on('click', '[data-track-exam-download]', () => {
  UserTracker.emit('event', {
    eventName: 'exam downloaded',
    data: {
      'source platform': 'portal',
      'source project': gon.source_project,
      'request path': window.location.pathname
    }
  });
});
